var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    { staticClass: "company", attrs: { to: _vm.link } },
    [
      _c("img", {
        directives: [
          {
            name: "tippy",
            rawName: "v-tippy",
            value: _vm.rowData.country.name,
            expression: "rowData.country.name",
          },
        ],
        staticClass: "flag",
        attrs: {
          src: _vm.rowData.country.flag || "//placehold.it/24x16",
          alt: _vm.rowData.country.name,
        },
      }),
      _vm._v(" "),
      _c("span", { class: { name: true, "not-read": !_vm.rowData.read } }, [
        _vm._v("\n            " + _vm._s(_vm.formattedTitle) + "\n        "),
      ]),
      _vm._v(" "),
      _vm.rowData.urgent
        ? _c("span", { staticClass: "pill pill--urgent" }, [_vm._v("Urgent")])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }